import { init, track } from '@amplitude/analytics-browser';

export const initAmplitude = () => {
  init(process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY!);
  if (process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY) {
    track('Checkout form opened'); // we dot it here to be really at launch of the app (not waiting for global attributes, requiring additional network requests)
  }
};
